/* ============================================================================
   Artline NON-PRESS PAINT MARKER — page chrome behaviours (VANILLA JS)
   #18: rewritten with zero jQuery / no Slick. Preserves EXACT behaviour:
     - mobile menu: the .menu button toggles the .gnav overlay (400ms fade),
       with focus management, in-overlay hash links that close it, and Escape.
     - smooth scroll: same-page anchors that have a real target, reduced-motion aware.
   Load order (deferred): main (THIS file) -> init.
   Self-guards against double-init.
   ============================================================================ */
(function () {
  'use strict';

  if (window.__artlineNpChrome) { return; }
  window.__artlineNpChrome = true;

  /* jQuery's default easing is "swing" (a cosine ease-in-out); this bezier matches it. */
  var SWING_BEZIER = 'cubic-bezier(0.45, 0, 0.55, 1)';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function toArray(list) {
    return Array.prototype.slice.call(list);
  }

  /* ---- mobile menu: hamburger <button class="menu"> toggles the .gnav overlay ---- */
  ready(function () {
    var menu = document.querySelector('.menu');
    var gnav = document.querySelector('.gnav');
    if (!menu || !gnav) { return; }

    var lastFocus = null;
    var navOpen = false;
    var anim = null;

    /* Replicates jQuery fadeIn/fadeOut: 400ms opacity tween with swing easing,
       toggling display so .gnav (display:none in CSS) shows/hides like before. */
    function fade(el, from, to, dur, done) {
      if (anim) { anim.cancel(); anim = null; }
      if (typeof el.animate !== 'function') {          // very old browser fallback
        el.style.opacity = String(to);
        if (done) { done(); }
        return;
      }
      var a = el.animate([{ opacity: from }, { opacity: to }], { duration: dur, easing: SWING_BEZIER });
      anim = a;
      a.onfinish = function () {
        el.style.opacity = String(to);
        anim = null;
        if (done) { done(); }
      };
    }

    function menuLines() {
      return toArray(document.querySelectorAll('.menu__line'));
    }

    function focusFirst() {
      var focusables = toArray(gnav.querySelectorAll('a, button, [tabindex]')).filter(function (el) {
        return el.offsetWidth || el.offsetHeight || el.getClientRects().length;
      });
      if (focusables.length) { focusables[0].focus(); }
    }

    function openNav() {
      if (navOpen) { return; }
      navOpen = true;
      lastFocus = document.activeElement;
      menuLines().forEach(function (l) { l.classList.add('active'); });
      menu.setAttribute('aria-expanded', 'true');
      gnav.style.display = 'block';
      gnav.style.opacity = '0';
      // move focus into the overlay once it has faded in
      fade(gnav, 0, 1, 400, focusFirst);
    }

    function closeNav(restoreFocus) {
      if (!navOpen) { return; }
      navOpen = false;
      menuLines().forEach(function (l) { l.classList.remove('active'); });
      menu.setAttribute('aria-expanded', 'false');
      var from = parseFloat(window.getComputedStyle(gnav).opacity);
      if (isNaN(from)) { from = 1; }
      fade(gnav, from, 0, 400, function () {
        gnav.style.display = 'none';
        gnav.style.opacity = '';
        if (restoreFocus && lastFocus && typeof lastFocus.focus === 'function') {
          lastFocus.focus();
        }
      });
    }

    menu.addEventListener('click', function (e) {
      e.preventDefault();
      if (navOpen) { closeNav(true); } else { openNav(); }
    });

    // In-page nav links inside the overlay: close it (don't steal focus back to
    // the hamburger — the smooth-scroll handler below moves the viewport).
    toArray(gnav.querySelectorAll('li.gnav__menu__item a[href^="#"]')).forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        closeNav(false);
      });
    });

    // Escape closes the overlay when it is open, and returns focus.
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.keyCode === 27) && navOpen) {
        closeNav(true);
      }
    });
  });

  /* ---- smooth scroll — same-page anchors that have a real target only ---- */
  ready(function () {
    function easeSwing(p) { return 0.5 - Math.cos(p * Math.PI) / 2; }

    function scrollTop() {
      return window.pageYOffset || document.documentElement.scrollTop || 0;
    }

    function animateScroll(toY, dur) {
      var startY = scrollTop();
      var diff = toY - startY;
      var startT = null;
      function step(ts) {
        if (startT === null) { startT = ts; }
        var p = Math.min((ts - startT) / dur, 1);
        window.scrollTo(0, startY + diff * easeSwing(p));
        if (p < 1) { requestAnimationFrame(step); }
      }
      requestAnimationFrame(step);
    }

    toArray(document.querySelectorAll('a[href^="#"]')).forEach(function (a) {
      a.addEventListener('click', function (e) {
        var hash = a.hash;
        if (!hash || hash === '#') { return; }               // ignore bare "#" placeholders
        var target;
        try {
          target = document.getElementById(hash.slice(1)) || document.querySelector(hash);
        } catch (err) {
          target = document.getElementById(hash.slice(1));
        }
        if (!target) { return; }                              // ignore anchors with no target
        e.preventDefault();
        // Offset by the sticky store header (added 2026-09-10); 0 when absent.
        var chromeH = typeof window.LPStickyChromeOffset === 'function' ? window.LPStickyChromeOffset() : 0;
        var targetPos = target.getBoundingClientRect().top + scrollTop() - chromeH;
        if (reduceMotion) {
          window.scrollTo(0, targetPos);
        } else {
          animateScroll(targetPos, 400);
        }
      });
    });
  });
})();
